// extracted by mini-css-extract-plugin
export default {"content":"index_content_5BwHE","clear_20":"index_clear_20_6jKG8","col":"index_col_q20SS"};